import { journeyApi } from "@/lib/journeyApi";

// Privacy-conscious, fire-and-forget product analytics. Only categorical props;
// never pass amounts, balances, or any financial values. The backend also
// strips anything numeric or money-looking as a second line of defence.
export function track(name, props) {
  try {
    journeyApi.trackEvent(name, props || {}).catch(() => {});
  } catch {
    /* analytics must never affect the UX */
  }
}
